import { render } from "./BaseTermCheckbox.vue?vue&type=template&id=1c17220a&scoped=true"
import script from "./BaseTermCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseTermCheckbox.vue?vue&type=script&lang=js"

import "./BaseTermCheckbox.vue?vue&type=style&index=0&id=1c17220a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c17220a"]])

export default __exports__